import { render, staticRenderFns } from "./invited.vue?vue&type=template&id=a136b4ce&"
import script from "./invited.ts?vue&type=script&lang=js&"
export * from "./invited.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports